import types from './types';

const INITIAL_STATE = {
    isFetching: false,
    isFetchingWrite: false,

  result: [],
};

const claimProviderListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_CLAIM_READ_PROVIDER_LIST_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_CLAIM_READ_PROVIDER_LIST_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_CLAIM_READ_PROVIDER_LIST_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    case types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingWrite: true,
        };

    case types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingWrite: false,
        };

    case types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingWrite: false,
        };

    default:
      return state;
  }
};

export default claimProviderListReducer;
